// Logger.js

export const logToServer = (message, level = 'INFO', context = {}) => {

  // Create a snapshot of the browser environment
  const browserContext = {
    innerHeight: window.innerHeight,
    innerWidth: window.innerWidth,
    // Optional: useful for identifying bots vs mobile/desktop
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    ...context 
  };
  
  console.log(message);
  
  fetch('/log', { // Send to the /log endpoint on the same origin
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ message, level, ...browserContext }), // Send message, level, and any extra context
  })
  .then(response => {
    if (!response.ok) {
      // It's still good practice to log errors related to sending the log itself
      console.error('Failed to send log to backend/proxy:', response.statusText);
    }
  })
  .catch(error => {
    console.error('Error sending log to backend/proxy:', error);
  });
};

// Helper functions for different log levels
export const logInfo = (message, context) => logToServer(message, 'INFO', context);
export const logWarning = (message, context) => logToServer(message, 'WARNING', context);
export const logError = (message, context) => logToServer(message, 'ERROR', context);
export const logDebug = (message, context) => logToServer(message, 'DEBUG', context);